import React, { memo } from 'react';
import './donation-info.scss';
import _ from 'lodash';
import { env } from '../../../../../environment';
import { Link } from 'react-router-dom';
import { RHYTHM_LIST, URL_PATHNAME } from '../../../../../utils/Utils';
import { withTranslation } from 'react-i18next';
import { parseFloatByLanguage, renderRegionName } from '../../../../../utils/functionCommon';

const DonationInfo = (props: any) => {
  const { donation, isSubscriptionDonation, formatDate, isFinishedSubsDonation, caclValues, token, t } = props;

  const getRhythm = (donation: any) => {
    return isSubscriptionDonation(donation) ? getRhythmBylanguage(donation.rhythm) : '';
  };

  const getRhythmBylanguage = (rhythm: number) => {
    const result = RHYTHM_LIST.find((f: any) => f.code === rhythm);
    return !!result ? (t('language') === 'en' ? result.name.en : result.name.de) : '';
  };

  const getDonationDateTime = (donation: any) => {
    const dateTime = !isSubscriptionDonation(donation)
      ? `${t('on')} ${formatDate(donation.payment_date)}`
      : isFinishedSubsDonation(donation)
        ? `${t('from')} ${formatDate(donation.payment_date)} ${t('to')} ${formatDate(donation.finished_date)}`
        : `${t('from')} ${formatDate(donation.payment_date)}`;
    return dateTime;
  };

  return (
    <div className="donation-info">
      <div className="donation-info-container">
        <div className="donation-details-header">
          <img
            className="donation-header-image"
            src={`${env.IMAGE_URL}/${donation.header_picture}`}
            alt={renderRegionName(donation.region_name)}
            loading="lazy"
          />
          <div className="donation-summary">
            <h1 className="donation-body-title">
              {renderRegionName(donation.campaign_name || donation.region_name)}
              <div className="action-map-wrapper">
                <a className="action-map" href={donation.map_url} target="_blank" rel="noreferrer">
                  <i className="fa-solid fa-map-location-dot" color="#FFFFFF"></i>
                </a>
              </div>
            </h1>
            <h4 className="donation-body-donate-date mb-2">
              <>{donation.nw_geo_coordinate}</>
            </h4>
            <h4 className="donation-body-donate-date lato-font">
              <>#{donation.serial}</>
            </h4>
            <h4 className="donation-body-donate-date lato-font">
              {getRhythm(donation) && (
                <>
                  {getRhythm(donation)} <br />
                </>
              )}
              <>{getDonationDateTime(donation)}</>
            </h4>
          </div>
          <div className="donation-serial">
            <div className="donor-content-item aw_container">
              <p className="item-content-text">
                {t('my_donation_description_1')}{' '}
                <span className="text-value">
                  {parseFloatByLanguage(caclValues.amount, t('language'), 2, 2)} {donation.currency_unit || '€'}
                </span>
                {t('my_donation_description_2')}{' '}
                <span className="text-value">
                  {parseFloatByLanguage(caclValues.area, t('language'))} m<sup>2</sup>
                </span>{' '}
                {t('my_donation_description_3')}{' '}
                <span className="text-value">
                  {parseFloatByLanguage(caclValues.co2, t('language'))} kg CO<sub>2</sub>
                </span>
                , {t('my_donation_description_4')}
              </p>
            </div>
            <div className="aw_container">
              <Link
                className="donation-body-header"
                onClick={() => window.scrollTo(0, 0)}
                to={`${URL_PATHNAME.DONOR_PORTAL}/${token}?lang=${t('language')}`}
              >
                <h4 className="donation-body-back">
                  <span className="icon-back">
                    <i className="fa-solid fa-chevron-left"></i>
                  </span>
                  {t('overview')}
                </h4>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation('language')(memo(DonationInfo));
